import countdownFactory from './countdown';
import removeWrongSmsCodeFactory from '../../../controllers/user/remove-wrong-sms-code';
var DEFAULT_COUNTDOWN_SEC = 5 * 60;
export default function smsVerificationController($timeout, $interval, pageContext) {

	var ctrl = this;

	$(document).on('transactions.verify', function (/* event, stateParams*/) {
		ctrl.smsCode = '';
	});

	ctrl.Mathfloor = Math.floor;
	ctrl.countdown = countdownFactory(ctrl, $interval);
	ctrl.notReceived = false;

	ctrl.serviceNotAvailable = false;

	ctrl.countDownSeconds = pageContext.remainingTime || ctrl.countDownSeconds || DEFAULT_COUNTDOWN_SEC;

	ctrl.sendSmsCode = function () {
		ctrl.disableSubmitButton = false;
		ctrl.loadingSpinner = true;
		if (typeof ctrl.sendSmsButtonFunction == 'function' && typeof ctrl.smsCode !== 'undefined') {
			ctrl.sendSmsButtonFunction({smsCode : ctrl.smsCode, additionalParam: ctrl.additionalParam, successCallback: ctrl.successCallback});
		}
	};

	ctrl.sendNewSms = function () {
		ctrl.disableSubmitButton = false;
		$interval.cancel(ctrl.countdown);
		ctrl.countDownSeconds = DEFAULT_COUNTDOWN_SEC; // azért kell, mert han lejárt, akkor 0 lesz, és nem indul el
		ctrl.countdown = countdownFactory(ctrl, $interval);
		$timeout(function () {
			ctrl.notReceived = false;
		}, 5000);
		if (typeof ctrl.sendNewSmsFunction == 'function') {
			ctrl.sendNewSmsFunction();
		}
	};
	ctrl.cancelButtonAction = function () {
		$interval.cancel(ctrl.countdown);
		ctrl.loadingSpinner = false;
		if (typeof ctrl.cancelButtonActionFunction == 'function' ) {
			ctrl.cancelButtonActionFunction();
		}
	};
	ctrl.removeWrongSmsCode = removeWrongSmsCodeFactory(ctrl);
}
